export const TAB_ITEMS = {
  SAAS: 'SAAS',
  INSTALLED: 'INSTALLED',
  MIDDLEWARE_AND_OS: 'MIDDLEWARE_AND_OS',
  SCRATCH: 'SCRATCH',
  PRODUCT: 'PRODUCT',
  ALL: 'ALL',
  DEACTIVATED: 'DEACTIVATED'
} as const;